import { render } from "./activity-modal.vue?vue&type=template&id=20a6c4b8"
import script from "./activity-modal.vue?vue&type=script&lang=js"
export * from "./activity-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__